import styled from 'styled-components';

const NoticeStyles = styled.section`
  padding: 1.5rem 0;
  background-color: var(--color-${(props) => props?.bgColor});
  text-align: center;

  .inner {
    display: flex;
    align-items: center;
    justify-content: center;

    .heading {
      font-weight: var(--font-weight-regular);
      margin: 0;
      color: ${(props) =>
        props?.bgColor === 'bark' || props?.bgColor === 'charcoal'
          ? '#fff'
          : 'var(--color-charcoal)'};
    }
  }

  @media (min-width: 768px) {
    padding: 1.75rem 0;
  }
`;

export default NoticeStyles;
